import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { GeneralDashboardContainer } from './GeneralDashboard2';
// import PhraseListContainer from './ErrorList/_PhraseListContainer';

const GeneralDashboard = props =>
  (<Grid fluid>
    <Row>
      <Col md={12}>
        <GeneralDashboardContainer {...props} />
      </Col>
    </Row>
  </Grid>);

export default GeneralDashboard;
